import React, { useState } from "react";

// Style //
import "./SubContractors.css";
import { images } from "../../../assets/index";

// Components //
import Table from "react-bootstrap/Table";
import { TableRowLoader } from "../../components/index";
import "react-toastify/dist/ReactToastify.css";
// Hooks //
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  archieveSoleTraderApi,
} from "../../../api/soleTraderApi";
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../../redux/actions/utilsActions";
import { toast } from "react-toastify";
import { baseUrl, soleTraderColorsEnum, soleTraderStatusEnum } from "../../../utils/constants";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";

const SubContractorsTable = ({ data }) => {
  // Hooks //
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.utils);
  const { userToken } = useSelector((state) => state.user);

  const [isArchiveModalVisible, setIsArchiveModalVisible] = useState(false)
  const [soleTraderIdToArchive, setSoleTraderIdToArchive] = useState(null)

  const archieveSoleTrader = async (sole_trader_id, archive, hide_training_matrix = false) => {
    const formData = {
      archive,
      sole_trader_id,
      hide_training_matrix
    }

    try {
      dispatch(requestSent());
      const data = await archieveSoleTraderApi(userToken, formData);
      dispatch(responseRecived());
      if (data.archive) {
        toast.success("Sole trader archived successfully!", {
          position: "top-right",
          autoClose: 3000, // Auto close after 3 seconds
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      navigate(0);
    } catch (error) {
      console.log("Sole Trader Details Error::::", error);
      dispatch(receivedError(error));
    } finally {
      setIsArchiveModalVisible(false)
    }
  };

  const getColorForSoleTraderStatus = (status) => {
    switch (status) {
      case soleTraderStatusEnum['ACTIVE']:
        return soleTraderColorsEnum['ACTIVE'];
      case soleTraderStatusEnum['INACTIVE']:
        return soleTraderColorsEnum['INACTIVE'];
      case soleTraderStatusEnum['MISSINGDOCS']:
        return soleTraderColorsEnum['MISSINGDOCS'];
      case soleTraderStatusEnum['Pending RIGHT TO WORK']:
        return soleTraderColorsEnum['Pending RIGHT TO WORK'];
      default:
        return 'white'
    }
  }

  const getSoleTraderStatus = (e) => {
    if (e === 'MISSINGDOCS') {
      return 'Pending Induction'
    } else if (e === 'PENDING_RIGHT_TO_WORK') {
      return 'Pending RIGHT TO WORK'
    } else {
      return e
    }
  }

  const ArchiveSoleTraderModal = () => {
    return (
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isArchiveModalVisible}
      >
        <Modal.Body>
          <div className="allert_img_cont">
            <h2>Do you want this subcontractor training details to remain on your training matrix?</h2>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            className="btn_style"
            variant="secondary"
            onClick={() => archieveSoleTrader(soleTraderIdToArchive, true, true)}
          >
            No
          </Button>
          <Button className="orange_btn btn_style" onClick={() => archieveSoleTrader(soleTraderIdToArchive, true, false)}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <>
      {loading ? (
        <TableRowLoader limit={8} />
      ) : (
        <>
          <ArchiveSoleTraderModal />
          <div style={{ overflowX: "auto", maxWidth: "100%" }}>
            <Table
              className="common-table sub-contractor_table"
              bordered
              style={{ width: "auto" }}
            >
              <thead style={{ width: "fit-content" }}>
                <tr>
                  <th>Subby Refrence No.</th>
                  <th></th>
                  <th>Subcontractor Name</th>
                  <th>Email</th>
                  <th>Mobile Number</th>
                  <th>Address</th>
                  <th>Status</th>
                  <th>Day Rate Measure</th>
                  <th>Rate of Pay</th>
                  <th>View Details</th>
                  <th>Edit Timesheet or Rate of Pay</th>
                  <th>Change Email</th>
                  <th>Archived Profile</th>
                  <th>Reinstate</th>
                </tr>
              </thead>
              <tbody style={{ width: "fit-content" }}>
                {!data?.length ? <td colSpan={14} style={{ fontSize: '1rem', textAlign:'center' }}>No Sub-Contractors Found</td> : data?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.id}</td>
                    <td>
                      <div className="profile_cont">
                        <div className="profile-img">
                          <img
                            src={
                              item.SoleTraderProfile.selfie_image
                                ? `${baseUrl}/sole_trader/onboarding/` + item.SoleTraderProfile.selfie_image
                                : images.PersonPlaceHolder
                            }
                            alt=""
                          />
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="profile-name_cont">
                        <p>
                          {
                            item?.SoleTraderProfile.company_name ? `${item.SoleTraderProfile.company_name} (${item?.SoleTraderProfile?.firstname} ${item?.SoleTraderProfile?.surname})` : `${item?.SoleTraderProfile?.firstname} ${item?.SoleTraderProfile?.surname}`
                          }
                        </p>
                      </div>
                    </td>
                    <td>
                      {item?.email ? item.email : ""}
                    </td>
                    <td>
                      {item?.SoleTraderProfile?.phone_number
                        ? item?.SoleTraderProfile?.phone_number
                        : ""}
                    </td>

                    <td>
                      {item?.address ? `${item?.address}, ${item?.SoleTraderProfile?.city}, ${item.SoleTraderProfile.postcode}` : (item?.SoleTraderProfile?.address ? `${item?.SoleTraderProfile?.address}, ${item?.SoleTraderProfile?.city}, ${item.SoleTraderProfile.postcode}` : '-')}
                    </td>

                    <td style={{ backgroundColor: getColorForSoleTraderStatus(item.status), color: item.status === soleTraderStatusEnum['INACTIVE'] ? 'white' : 'black' }}>
                      {getSoleTraderStatus(item.status)}
                    </td>
                    <td>
                      {item?.WorkUnit &&
                        (item.WorkUnit === "AREA"
                          ? "Measure"
                          : item.WorkUnit === "DAYS"
                            ? "Day Rate"
                            : item.WorkUnit === "HOURS"
                              ? "Hour Rate"
                              : "")}
                    </td>
                    <td>
                      {item?.Contractors[0]?.daily_pay_rate
                        ? `£${item?.Contractors[0]?.daily_pay_rate}`
                        : ""}
                    </td>
                    <td>
                      <button
                        onClick={() =>
                          navigate(
                            `/sub-contractors/sub-contractor-profile?id=${item.id}`
                          )
                        }
                      >
                        View Details
                      </button>
                    </td>
                    <td>
                      <Link
                        className="link"
                        to={`/sub-contractors/edit-timeSheet/${item.id}`}
                      >
                        Edit
                      </Link>
                    </td>
                    <td>
                      <Link
                        className="link"
                        to={`/sub-contractors/edit-sub-contractor-email/${item.id}?email=${encodeURIComponent(item.email)}`}
                      >
                        Edit
                      </Link>
                    </td>
                    {item.status === soleTraderStatusEnum['ARCHIVED'] ? (
                      <td></td>
                    ) : (
                      <td>
                        <button
                          style={{
                            borderColor: "orange",
                            borderWidth: "1",
                            fontWeight: "lighter",
                          }}
                          onClick={() => {
                            setSoleTraderIdToArchive(item.id)
                            setIsArchiveModalVisible(true)
                          }}>
                          ARCHIVE
                        </button>
                      </td>
                    )}

                    {item.status !== soleTraderStatusEnum['ARCHIVED'] ? (
                      <td></td>
                    ) : (
                      <td>
                        <button
                          style={{
                            borderColor: "orange",
                            borderWidth: "1",
                            fontWeight: "lighter",
                          }}
                          onClick={() => {
                            archieveSoleTrader(item.id, false);
                          }}
                        >
                          REINSTATE
                        </button>
                      </td>
                    )}
                    {/* <td>
                  <span>...</span>
                </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
    </>
  );
};

export default SubContractorsTable;
